import { api } from '../utils/api'
import type { User } from '../types/@types/user'

interface UserApi {
  id: string
  name: string
  email: string
  phone: string
  role: string
  status: 'active' | 'inactive'
  registeredAt?: string
  lastLogin?: string
  avatarUrl?: string
  lastPasswordChange?: string
}

function mapUser(user: UserApi): User {
  const { id, ...rest } = user
  return { id: id, ...rest }
}

export interface AuthResponse {
  token: string
  user: User
}

interface AuthResponseApi {
  token: string
  user: UserApi
}

export async function login(
  email: string,
  password: string
): Promise<AuthResponse> {
  const { data } = await api.post<AuthResponseApi>('/auth/login', {
    email,
    password,
  })
  return { token: data.token, user: mapUser(data.user) }
}

export async function getMe(): Promise<User> {
  const { data } = await api.get<UserApi>('/auth/me')
  return mapUser(data)
}

export async function logout(): Promise<void> {
  await api.post('/auth/logout')
}
